import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { DateField, RadioField, TextField } from '../../atoms';
import { Row, Col, Alert } from 'antd';

import {
  FORM_ACTIVITY_PERIOD,
  activityPeriodFormFields,
} from '../../constants/formsAddEquipment';

import { RegisterActions } from '../../components';
import { parseNumber } from '../../utils/formHelpers';
import { updateProductionUnit } from '../../actions/actionCreators/productionUinitActionCreators';
import validate from './validateSchema';

import FormStateToRedux from '../FormStateToRedux';
import { formValueSelector } from '../../reducers/reactFinalFormReducer';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import { isEqual } from 'lodash/fp';
import { FormSpy } from 'react-final-form/dist';

export class AddEquipmentActivityPeriod extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    productionUnit: PropTypesImmutable.map.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    showRequestChangeModal: PropTypes.func,
    subsidyEligible: PropTypes.bool,
    onSubmitSuccess: PropTypes.func,

    // data
    initialValues: PropTypesImmutable.map,

    // actions
    updateProductionUnit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.validate = makeRffValidateFromLegacy(
      validate,
      props,
      props.initialValues
    );
  }

  onSubmit = async (values) => {
    await this.props.updateProductionUnit(values);
    this.props.onSubmitSuccess?.();
  };

  render() {
    const {
      t,
      hasPrevious,
      hasDone,
      goPrevious,
      isAdmin,
      isEditMode,
      showRequestChangeModal,
      subsidyEligible,
      productionUnit,
    } = this.props;

    return (
      <Form
        initialValues={productionUnit.toJS()}
        initialValuesEqual={isEqual}
        validate={isAdmin ? this.validate : undefined}
        onSubmit={this.onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FormStateToRedux form={FORM_ACTIVITY_PERIOD} />

            <h2>{t('activityPeriod.title')}</h2>

            {!isEditMode && !isAdmin && (
              <Alert
                message={t('activityPeriod.registerWarning')}
                type="warning"
              />
            )}

            <Row gutter={32}>
              <Col span={12}>
                <Field
                  name={activityPeriodFormFields.ELIGIBLE_FOR_SUBSIDY}
                  component={RadioField}
                  required
                  options={[
                    {
                      value: true,
                      label: t('activityPeriod.subsidyEligible.trueLabel'),
                    },
                    {
                      value: false,
                      label: t('activityPeriod.subsidyEligible.falseLabel'),
                    },
                  ]}
                  type="text"
                  label={t('activityPeriod.subsidyEligible.label')}
                  disabled={!isAdmin}
                  hasFeedback={isAdmin}
                />
              </Col>
            </Row>

            <Row gutter={32}>
              <Col span={8}>
                <Field
                  label={t('activityPeriod.decisionDate')}
                  name={activityPeriodFormFields.DECISION_DATE}
                  required
                  component={DateField}
                  disabled={!isAdmin}
                  hasFeedback={isAdmin}
                />
              </Col>
              <Col span={8}>
                <Field
                  name={activityPeriodFormFields.DECISION_NUMBER}
                  component={TextField}
                  parse={parseNumber}
                  type="text"
                  label={t('activityPeriod.decisionNumber')}
                  disabled={!isAdmin}
                  hasFeedback={isAdmin}
                />
              </Col>
            </Row>

            {/* set START_DATE and END_DATE to undefined when ELIGIBLE_FOR_SUBSIDY is toggled false */}
            <FormSpy subscription={{ values: true }}>
              {({ values, form }) => {
                const eligible =
                  values?.[activityPeriodFormFields.ELIGIBLE_FOR_SUBSIDY];
                const start = values?.[activityPeriodFormFields.START_DATE];
                const end = values?.[activityPeriodFormFields.END_DATE];

                if (eligible === false) {
                  if (start)
                    form.change(activityPeriodFormFields.START_DATE, undefined);
                  if (end)
                    form.change(activityPeriodFormFields.END_DATE, undefined);
                }
                return null;
              }}
            </FormSpy>

            {subsidyEligible && (
              <Row gutter={32}>
                <Col span={8}>
                  <Field
                    label={t('activityPeriod.startDate')}
                    name={activityPeriodFormFields.START_DATE}
                    required
                    type="text"
                    component={DateField}
                    disabled={!isAdmin}
                  />
                </Col>
                <Col span={8}>
                  <Field
                    name={activityPeriodFormFields.END_DATE}
                    component={DateField}
                    type="text"
                    label={t('activityPeriod.endDate')}
                    disabled={!isAdmin}
                    hasFeedback={isAdmin}
                  />
                </Col>
              </Row>
            )}

            <RegisterActions
              showRequestChangeModal={showRequestChangeModal}
              hasPrevious={hasPrevious}
              hasDone={hasDone}
              goPrevious={goPrevious}
              t={t}
              isEditMode={isEditMode}
              showSaveButton={isAdmin || !isEditMode}
              isAdmin={isAdmin}
            />
          </form>
        )}
      />
    );
  }
}

const getFormValue = formValueSelector(FORM_ACTIVITY_PERIOD);

const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.productionUnit,
  subsidyEligible: getFormValue(
    state,
    activityPeriodFormFields.ELIGIBLE_FOR_SUBSIDY
  ),
});

const mapDispatchToProps = {
  updateProductionUnit,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEquipmentActivityPeriod);
